const levels = [];

/**
 * Filter course
 * @param {string} level Level
 * @returns {string[]} Levels
 */
const filterCourses = (level) => {
  if (level !== "-1") {
    const level_index = levels.indexOf(level);
    if (level_index !== -1) {
      levels.splice(level_index, 1);
    } else {
      levels.push(level);
    }
  } else {
    levels.splice(levels.length);
  }

  return levels;
};

export default filterCourses;
